import { useQuery } from "@tanstack/react-query";
import apiClient from '../services/api/apiClient';
import { ItemListProduct } from '../types/post.type';

const fetchRelatedPosts = async (postId: string, postType: string, page: number): Promise<ItemListProduct[]> => {
  try {
    const response = await apiClient.get(`/posts/lists/${postType}/related/paged/${page}/?filter=post_id__${postId}`);
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching related posts:", error);
    return [];
  }
};

export const useRelatedPosts = (postId: string, postType: string = 'movie', page: number = 1) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [`relatedPosts-${postType}-${postId}`, page],
    queryFn: () => fetchRelatedPosts(postId, postType, page),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!postId // Only run the query if we have a postId
  });

  return {
    data: data || [],
    isLoading,
    error,
    refetch
  };
};
